import logo from './logo.svg';
import './App.css';
import config from './config';
import React, { useContext, useState, useEffect, useReducer } from 'react';
import { SearchContext } from "./context";
import { rootlink, URL_MW, thumbnailConfig, blue } from './config';
import { default_config, default_viewinfo, default_photolist, default_branchlist, default_planlist, imgConfig, category_mapping, menu_mapping, plates, order_mapping_search } from './config';
import './css/common.scss';
import './css/bulma-tune.scss';
/////////////// swiper start 
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Thumbs } from 'swiper/core';
import loadingicon from './img/loading.gif';
import { Navigation, Pagination, Scrollbar, A11y, Lazy } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
/////////////// swiper end 
import { Fancybox as NativeFancybox } from "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import $ from "jquery";

import AppDesktop from './AppDesktop';
import AppMobile from './AppMobile';

var ts = 0;

const App = () => {

  const navigate = useNavigate();

  function golink(p) {
    var url = rootlink + "details?id=" + p['value'];
    window.open(url, '_blank');
  }

  function ltrbox(action) {
    if (action == "show") {
      // document.getElementById('lightrail').style.display = 'block';
      $("#lightrail").fadeIn(500);
    } else {
      // document.getElementById('lightrail').style.display = 'none';
      $("#lightrail").fadeOut(500);
    }
  }

  const [searchParams, setSearchParams] = useSearchParams();
  const viewid = searchParams.get("id");
  // const params = useParams();
  // const viewid = params.id;

  const [firstSwiper, setFirstSwiper] = useState(null);
  const [secondSwiper, setSecondSwiper] = useState(null);

  // const page = useContext(SearchContext).page;
  const [loaded, setLoaded] = useState(false);
  const [viewinfo, setViewInfo] = useState(default_viewinfo);
  const [photolist, setPhotoList] = useState(default_photolist);
  const [planlist, setPlanList] = useState(default_planlist);
  const [branchlist, setBranchList] = useState(default_branchlist);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [config, setConfig] = useReducer(function (state, action) {
    switch (action.type) {
    }
    return state;
  }, JSON.parse(JSON.stringify(default_config)));

  const search = () => {
    var url;
    ts = new Date().getTime();
    url = "https://www.manyw.com/view/view_prop.php?category=viewview&auto_no=" + viewid;
    url += "&thumbnail_width=" + imgConfig.width;
    url += "&thumbnail_height=" + imgConfig.height;
    url += '&ts=' + ts;

    console.log(url);
    setLoaded(false);
    fetch(url, { method: "POST", body: config })
      .then(res => res.json())
      .then(res => {
        // console.log(res);
        if (res.ts == ts) {
          setViewInfo(res['data']);
          setPhotoList(res['data']['photo_list']);
          setPlanList(res['data']['plan_list']);
          setBranchList(res['data']['branch_list']);
          setLoaded(true);
          document.title = viewinfo['address'] + " - 祥益地產";
        }
      })
      .catch(err => console.log(err))
      .finally(() => { });
  }

  var photolist3d = [];
  if (photolist != null) {
    for (var i = 0; i < photolist.length; i += 4) {
      photolist3d.push([photolist[i], photolist[i + 1], photolist[i + 2], photolist[i + 3]]);
    }
  }

  var planslist3d = [];
  if (planlist != null) {
    for (var i = 0; i < planlist.length; i += 4) {
      planslist3d.push([planlist[i], planlist[i + 1], planlist[i + 2], planlist[i + 3]]);
    }
  }

  useEffect(() => {
    search();
  }, [
    JSON.stringify(config.bldg),
    config.region.length,
    config.rent.from,
    config.rent.to,
    config.room.length,
    config.floor.length,
    config.net.from,
    config.net.to,
    config.proptype.length,
  ]);
  useEffect(() => {
    document.title = viewinfo['address'] + " - 祥益地產";
  }, [
    loaded
  ]);

  if (loaded) {
    console.log(viewinfo['layoutLine']);
  }

  return (<div>

    {/*App.sql1*/}
    <div className='mobile-hidden'>
      <AppDesktop
        loaded={loaded}
        viewinfo={viewinfo}
        photolist={photolist}
        planlist={planlist}
        branchlist={branchlist}
      />
    </div>

    <div className='mobile-display'>
      <AppMobile
        loaded={loaded}
        viewinfo={viewinfo}
        photolist={photolist}
        planlist={planlist}
        branchlist={branchlist}
      />
    </div>

  </div>
  )

  return null;
}

export default App;
